import handheld_s4a1_screen1 from "./handleheld_s4a1_screen1.svg";
import handheld_s4a1_screen2 from "./handheld_s4a1_screen2.svg";
import handheld_s4a1_screen3 from "./handheld_s4a1_screen3.svg";
import handheld_s4a1_screen4 from "./handheld_s4a1_screen4.svg";
import handheld_s4a1_screen5 from "./handheld_s4a1_screen5.svg";

export const handHeldsScreensTopicFor = {
	handheld_s4a1_screen1,
	handheld_s4a1_screen2,
	handheld_s4a1_screen3,
	handheld_s4a1_screen4,
	handheld_s4a1_screen5,
};
